var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partners-flex"},_vm._l((_vm.imgList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('img',{attrs:{"src":item.imgUrl,"alt":item.imgUrl}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }